export default __webpack_public_path__ + "static/colibri-7-web-e418f2dae0b268dccf84b6be1306e9fc.pdf";